import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, TransitionGroup as _TransitionGroup, withCtx as _withCtx, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5538a474"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "mb-[13px] ml-[6px] text-left text-[24px] font-bold leading-[160%] tracking-[-0.035em] text-white" }, " 사진 업로드 ", -1))
const _hoisted_2 = { class: "mb-[26px] w-full" }
const _hoisted_3 = { class: "mb-[6px] flex w-full items-center justify-between" }
const _hoisted_4 = ["src"]
const _hoisted_5 = ["src"]
const _hoisted_6 = ["src"]
const _hoisted_7 = ["src"]
const _hoisted_8 = {
  key: 2,
  class: "relative h-full w-full overflow-hidden rounded-[14px]"
}
const _hoisted_9 = ["src", "alt"]
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "mb-[26px] flex justify-between text-center text-[14px] font-normal leading-[136%] tracking-[-0.015em] text-white" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "w-[181px]" }, "1번째 사진"),
  /*#__PURE__*/_createElementVNode("div", { class: "w-[181px]" }, "2번째 사진"),
  /*#__PURE__*/_createElementVNode("div", { class: "w-[181px]" }, "가상 얼굴 결과")
], -1))
const _hoisted_11 = { class: "flex h-[50px] w-full" }
const _hoisted_12 = { class: "mr-5 flex flex-1 items-center gap-2 rounded-[8px] bg-[#292E38]" }
const _hoisted_13 = { class: "w-[54px] text-center text-[20px] font-semibold leading-[150%] text-[#6150FF]" }
const _hoisted_14 = { class: "w-[54px] text-center text-[20px] font-semibold leading-[150%] text-[#6150FF]" }
const _hoisted_15 = {
  key: 0,
  class: "relative flex h-full w-full items-center justify-center transition-all"
}
const _hoisted_16 = { class: "absolute flex items-center text-[14px] font-bold leading-[136%] text-white" }
const _hoisted_17 = ["src"]
const _hoisted_18 = {
  key: 1,
  class: "absolute flex items-center transition-all"
}
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-[14px] font-bold leading-[136%] text-white" }, "얼굴 사진 합성하기", -1))
const _hoisted_20 = [
  _hoisted_19
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_UploadPicture = _resolveComponent("UploadPicture")!
  const _component_Slider = _resolveComponent("Slider")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _hoisted_1,
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_UploadPicture, {
          class: "h-[181px] w-[183px]",
          onChange: _cache[0] || (_cache[0] = (e) => _ctx.formData.faceAToken = e)
        }),
        _createElementVNode("img", {
          src: require('@assets/icons/Plus.svg')
        }, null, 8, _hoisted_4),
        _createVNode(_component_UploadPicture, {
          class: "h-[181px] w-[183px]",
          onChange: _cache[1] || (_cache[1] = (e) => _ctx.formData.faceBToken = e)
        }),
        _createElementVNode("img", {
          src: require('@assets/icons/Equal.svg')
        }, null, 8, _hoisted_5),
        _createElementVNode("div", {
          class: _normalizeClass(["relative flex h-[181px] w-[183px] items-center justify-center rounded-[20px] border-[2px] border-solid bg-[#333942] p-3", [_ctx.result.length > 0 ? 'border-[#6150FF]' : 'border-[#333942]']])
        }, [
          _createVNode(_TransitionGroup, { name: "fade" }, {
            default: _withCtx(() => [
              (_ctx.result.length === 0 && _ctx.isLoading)
                ? (_openBlock(), _createElementBlock("img", {
                    key: 0,
                    src: require('@assets/icons/Loading.svg'),
                    class: "absolute h-9 animate-spin transition-all"
                  }, null, 8, _hoisted_6))
                : _createCommentVNode("", true),
              (_ctx.result.length === 0 && !_ctx.isLoading)
                ? (_openBlock(), _createElementBlock("img", {
                    key: 1,
                    src: require('@assets/icons/ResultPicture.svg'),
                    class: "absolute transition-all"
                  }, null, 8, _hoisted_7))
                : _createCommentVNode("", true),
              (_ctx.result.length > 0 && !_ctx.isLoading)
                ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                    _createElementVNode("img", {
                      src: _ctx.result,
                      alt: _ctx.result,
                      class: "h-full w-full object-cover"
                    }, null, 8, _hoisted_9)
                  ]))
                : _createCommentVNode("", true)
            ]),
            _: 1
          })
        ], 2)
      ]),
      _hoisted_10,
      _createElementVNode("div", _hoisted_11, [
        _createElementVNode("div", _hoisted_12, [
          _createElementVNode("div", _hoisted_13, _toDisplayString(_ctx.formData.mixtureA), 1),
          _createVNode(_component_Slider, {
            modelValue: _ctx.formData.mixtureB,
            "onUpdate:modelValue": [
              _cache[2] || (_cache[2] = ($event: any) => ((_ctx.formData.mixtureB) = $event)),
              _cache[3] || (_cache[3] = (e) => (_ctx.formData.mixtureA = 100 - e))
            ]
          }, null, 8, ["modelValue"]),
          _createElementVNode("div", _hoisted_14, _toDisplayString(_ctx.formData.mixtureB), 1)
        ]),
        _createElementVNode("button", {
          type: "submit",
          class: _normalizeClass(["relative flex w-[181px] items-center justify-center rounded-[8px] border-2 border-solid transition-all", [
          {
            'pointer-events-none':
              _ctx.isLoading || _ctx.formData.faceAToken.length === 0 || _ctx.formData.faceBToken.length === 0,
          },
          _ctx.formData.faceAToken.length > 0 && _ctx.formData.faceBToken.length > 0
            ? 'border-[#6150FF] bg-[rgba(97,80,255,0.16)]'
            : 'border-[rgba(131,144,165,0.6)] bg-[rgba(131,144,165,0.6)]',
        ]]),
          onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.handleMerge && _ctx.handleMerge(...args)))
        }, [
          _createVNode(_TransitionGroup, { name: "fade" }, {
            default: _withCtx(() => [
              (_ctx.isLoading)
                ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                    _createElementVNode("div", _hoisted_16, [
                      _createElementVNode("img", {
                        src: require('@assets/icons/Loading.svg'),
                        class: "mr-1 h-9 animate-spin"
                      }, null, 8, _hoisted_17),
                      _createTextVNode(" " + _toDisplayString(_ctx.state.progress), 1)
                    ])
                  ]))
                : (_openBlock(), _createElementBlock("div", _hoisted_18, _hoisted_20))
            ]),
            _: 1
          })
        ], 2)
      ])
    ])
  ], 64))
}